import { getTextLayerElements, wrapRangeInTextNodes } from '@/util/pdf-viewer-util';

const DEFAULT_HIGHLIGHT_COLOR = '#ff0000';

export default {
  methods: {
    highlightSearchResults(pageNumber, searchResults, docId, color) {
      const pageElements = getTextLayerElements(pageNumber);
      if (!pageElements.length) return;
      const highlightColor = color || DEFAULT_HIGHLIGHT_COLOR;
      let pageOccurrence = 0;
      searchResults.forEach((searchResult) => {
        if (searchResult.documentId !== docId) {
          return;
        }
        searchResult.spans.forEach((match) => {
          if (match.start.page !== pageNumber) {
            return;
          }

          this.addBackgroundColorToSearchResult(
            pageElements,
            match.start.element,
            match,
            pageOccurrence,
            highlightColor,
          );
          pageOccurrence++;
        });
      });
    },
    addBackgroundColorToSearchResult(pageElements, currentElementNumber, match, pageOccurrence, color) {
      const currentElement = pageElements[currentElementNumber];
      if (!currentElement) {
        console.warn(`Element number ${currentElementNumber} not found for match: ${JSON.stringify(match)}`);
        return;
      }

      if (currentElement.nodeName === 'BR') {
        if (currentElementNumber + 1 <= match.end.element) {
          this.addBackgroundColorToSearchResult(pageElements, currentElementNumber + 1, match, pageOccurrence, color);
        }
        return;
      }

      const startOffset = currentElementNumber === match.start.element ? match.start.offset : 0;
      const endOffset = currentElementNumber === match.end.element ? match.end.offset : currentElement.innerText.length;
      if (
        currentElement.nodeName === 'SPAN' &&
        currentElement.innerText.length >= startOffset &&
        currentElement.innerText.length >= endOffset
      ) {
        const highlightedKeywordSpan = document.createElement('keyword');
        highlightedKeywordSpan.style.backgroundColor = color;
        highlightedKeywordSpan.style.borderRadius = '4px';
        highlightedKeywordSpan.classList.add(`keyword-${null}-${pageOccurrence}`);
        wrapRangeInTextNodes(currentElement, startOffset, endOffset, highlightedKeywordSpan);

        if (currentElementNumber + 1 <= match.end.element) {
          this.addBackgroundColorToSearchResult(pageElements, currentElementNumber + 1, match, pageOccurrence, color);
        }
      }
    },
  },
};
